/**
 * 诱导弹窗
 * */
import { useMount } from 'ahooks';
import { useMemo, useState } from 'react';

import { implog } from '@/api/implog';
// import Score from '@/assets/modal/receive_score.webp';
import Button from '@/components/button';
import BlurryLoadingImage from '@/components/progressive-img';
import { ACCESS_USERID_KEY } from '@/constant/config';
import useEntrygame from '@/hooks/useEntryGame';
import { gameActions } from '@/jotai/game';
import globalStore from '@/stores/store';
import { request } from '@/utils/request';
import Storage from '@/utils/Storage';
import { isGuestUser } from '@/utils/utils';

import styles from './styles.module.less';

const ReceiveModal = (modal, onClose) => {
  const {
    initialAwardconfig,
    initialState: { score, isLogin }
  } = globalStore;
  const { runEntry } = useEntrygame();
  const [loading, setLoading] = useState(false);
  const { mobilereg, guestreg } = initialAwardconfig;

  const amount = useMemo(() => {
    if (isGuestUser()) {
      return guestreg;
    }
    return mobilereg;
  }, [initialAwardconfig, isLogin]);

  useMount(async () => {
    implog('receive_modal_show');
  });

  return (
    <>
      <div className={styles.main}>
        <BlurryLoadingImage
          loading="lazy"
          src={`${window?.imgPrefix || ''}/img/modal/receive_score.webp`}
          className={styles.score}
        />
        <div className={styles.content}>
          <div className={styles.text}>You&apos;ve won</div>
          <div className={styles.amount}>${amount}</div>
        </div>
        <div className={styles.footer}>
          <Button
            type="success"
            size="large"
            block
            disabled={loading}
            onClick={async () => {
              let pack = '';
              setLoading(true);
              try {
                const res = await gameActions.getGuideGame({
                  p_userid: Storage.getAccess(ACCESS_USERID_KEY)
                });
                pack = res.game;
              } catch (e) {
                setLoading(false);
                console.error(e);
              }

              if (!pack) {
                pack = 'ermj';
              }
              const gameLayout = await request({
                url: '/gamer/get_game_layout',
                method: 'post',
                data: {
                  directIn: 1,
                  version: 1,
                  roomconfigname: import.meta.env.VITE_GAME_ROOM_CONFIG_NAME,
                  configname: import.meta.env.VITE_GAME_CONFIG_NAME
                }
              });
              const game = gameLayout.config.flat().find(item => item.pack === pack);
              if (game) {
                runEntry(game);
              }
            }}
          >
            OK
          </Button>
        </div>
      </div>
      <div
        className={styles.close}
        onClick={() => {
          modal.resolve({ onClose });
        }}
      ></div>
    </>
  );
};

export default ReceiveModal;
